import { styled, Tooltip, tooltipClasses, TooltipProps } from "@mui/material";
import { ReactElement, ReactNode } from "react";

type TooltipPlacement =
  | "bottom-end"
  | "bottom-start"
  | "bottom"
  | "left-end"
  | "left-start"
  | "left"
  | "right-end"
  | "right-start"
  | "right"
  | "top-end"
  | "top-start"
  | "top"
  | undefined;

type CustomTooltipProps = {
  title: string | ReactNode;
  children: ReactElement;
  hideTooltip?: boolean;
  placement?: TooltipPlacement;
};

const CustomTooltip = ({
  title,
  children,
  hideTooltip = false,
  placement = "top",
}: CustomTooltipProps) => {
  const HtmlTooltip = styled(({ className, ...props }: TooltipProps) => (
    <Tooltip
      {...props}
      classes={{ popper: className }}
      arrow
      disableHoverListener={hideTooltip}
      placement={placement}
    />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "white",
      color: "rgba(0, 0, 0, 0.87)",
      maxWidth: 400,
      fontSize: theme.typography.pxToRem(14),
      borderRadius: "10px",
      filter: "drop-shadow(0 0 5px rgba(0, 0, 0, 0.5))",
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: "white",
    },
  }));

  return <HtmlTooltip title={<div>{title}</div>}>{children}</HtmlTooltip>;
};

export default CustomTooltip;
